/* eslint-disable no-irregular-whitespace */
import { HTMLProps } from 'react';
import { css, keyframes, Theme } from '@emotion/react';
import { borderRadius } from 'client/Theme';

const pulseAnimation = keyframes`
  0% { opacity: 0.5; };
  100% { opacity: 1; };
`;

const skeletonStyle = (theme: Theme) => css`
  display: block;
  background-color: ${theme.color.grey[60]};
  border-radius: ${borderRadius}px;
`;

const inlineStyle = css`
  display: inline-block;
`;

const animationStyle = css`
  animation: ${pulseAnimation} 1s infinite alternate;
`;

const textStyle = css`
  transform: scaleY(0.8);

  ::before {
    content: ' ';
  }
`;

const buttonStyle = css`
  height: 41.5px;
  border-radius: 64px;
`;

const iconStyle = css`
  width: 32px !important;
  height: 32px;
  border-radius: 50%;
`;

type SkeletonType = 'text' | 'button' | 'icon' | 'rect';

export type SkeletonProps = HTMLProps<HTMLDivElement> & {
  type?: SkeletonType;
  width?: string | number;
  height?: string | number;
  inline?: boolean;
  animate?: boolean;
};

export const Skeleton = ({
  type = 'text',
  width = '100%',
  height = undefined,
  inline = false,
  animate = true,
  style = {},
  ...props
}: SkeletonProps) => (
  <span
    css={[
      skeletonStyle,
      inline && inlineStyle,
      animate && animationStyle,
      type === 'text' && textStyle,
      type === 'button' && buttonStyle,
      type === 'icon' && iconStyle,
    ]}
    style={{ width, height, transform: height === undefined ? undefined : 'none', ...style }}
    className="skeleton"
    {...props}
  />
);
